import React from "react";
import spinner from "../../img/spinner.gif";

export default () => {
  return (
    <div className="center">
      <img src={spinner} alt="Loading..." className="spinner" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Spinner.js